/**
 * Created by mukund on 12/14/17.
 */

angular.module('mediacloudApp')
    .directive('pnpRecorder', ['$interval', 'WebcamService', 'BatchService', 'BaseFileService', 'JobService', 'UploadErrors',
        function($interval, WebcamService, BatchService, BaseFileService, JobService, UploadErrors){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/recorder/recorder.html',
            scope: {
                activeLink: '='
            },
            link: function(scope, element, attr){

                var recordingFilePath;

                scope.webcamState = 'idle';

                var startWebcam = function(){
                    scope.file = { state: 'IDLE' };
                    WebcamService.startLocalStream(document.getElementById('localVideo'));
                    recordingFilePath = WebcamService.getRecordingFilePath();
                    angular.element('.recordtimer').text("00 : 00 : 00");
                    scope.webcamState = 'started';
                };

                scope.$watch('activeLink', function(){
                    if(scope.activeLink) {
                        if(scope.activeLink === 'record') {
                            scope.supported = WebcamService.isSupported();
                            if (scope.supported) {
                                startWebcam();
                            }
                        } else {
                            if(!WebcamService.isIdle()) {
                                WebcamService.destroyWebcam();
                            }
                        }
                    }
                });

                scope.startRecording = function(){
                    scope.webcamState = 'recording';
                    WebcamService.startRecording(document.getElementById('remoteVideo'), angular.element('.recordtimer'));
                };

                scope.stopRecording = function(){
                    WebcamService.stopRecording();
                    var timer = $interval(function () {
                        if(WebcamService.isStopped()){
                            scope.webcamState = 'readyForReview';
                            $interval.cancel(timer);
                        }
                    }, 100);
                };

                scope.playRecording = function(){
                    scope.webcamState = 'reviewing';
                    WebcamService.playRecording(document.getElementById('videoReview'), document.getElementById('localVideo'));
                };

                scope.discardRecording = function(){
                    WebcamService.destroyWebcam();
                    var timer = $interval(function () {
                        if(WebcamService.isIdle()){
                            scope.showDiscardDialog = false;
                            startWebcam();
                            $interval.cancel(timer);
                        }
                    }, 100);
                };

                scope.cancelRecording = function(){
                    if(WebcamService.isIdle()){
                        scope.showDiscardDialog = false;
                        startWebcam();
                    }
                };

                scope.saveRecording = function(){
                    WebcamService.destroyWebcam();
                    console.log("Uploading file to Hotfolders...");

                    // Create a batch for the file in Hotfolders
                    var addBatchRequest = new BatchService.CreateBatch();
                    addBatchRequest.$save(function(batch){

                        console.log("Batch successfully created with batchId: " + batch.batchId);
                        var addBaseFileRequest = {};
                        addBaseFileRequest.batchId = batch.batchId;
                        addBaseFileRequest.fileName = 'recording';
                        addBaseFileRequest.autoPublish = false;
                        scope.file.selectedThumbnail = {id: '000', url: 'assets/images/noThumbnail.jpg'};
                        scope.file.thumbnails = [].push(scope.file.selectedThumbnail);

                        // Create a BaseFile entity for the file in MediaCloud
                        var baseFileResource = new BaseFileService.AddBaseFile(addBaseFileRequest);
                        baseFileResource.$save(function(baseFile){

                            scope.file.mediacloudFileId = baseFile.id;

                            scope.file.state = 'UPLOADING';

                            // Upload the file to Hotfolders
                            var captureResource = new WebcamService.saveRecording({filePath: recordingFilePath});
                            captureResource.$save(function(captureFile){

                                console.log("File successfully uploaded to Hotfolders with fileId: " + captureFile.id);
                                scope.file.fileId = captureFile.id;
                                var updateBaseFileRequest = {};
                                updateBaseFileRequest.id = scope.file.mediacloudFileId;
                                updateBaseFileRequest.fileId = scope.file.fileId;
                                if(captureFile.thumbnails) {
                                    scope.file.thumbnails = captureFile.thumbnails;
                                    scope.file.selectedThumbnail = captureFile.thumbnails[0];
                                    updateBaseFileRequest.thumbnailId = captureFile.thumbnails[0].id;
                                }

                                // Update the MediaCloud BaseFile with the fileId and thumbnailId
                                var baseFileResource = new BaseFileService.UpdateBaseFile(updateBaseFileRequest);
                                baseFileResource.$update(function (bfe) {

                                    scope.file.state = 'UPLOADED';
                                    var createJobRequest = {};
                                    createJobRequest.batchId = batch.batchId;
                                    createJobRequest.fileId = scope.file.fileId;
                                    createJobRequest.profiles = [];
                                    createJobRequest.transcodeFile = true;
                                    createJobRequest.subtitles = [
                                        {
                                            'language': 'English',
                                            'listOrder': 1,
                                            'enabledByDefault': true
                                        }
                                    ];

                                    // Create a job for the file in Hotfolders
                                    JobService.CreateJob().getNewJob(createJobRequest)
                                        .then(function(job){
                                            if(job) {
                                                console.log("Job successfully created with jobId: " + job.jobId);
                                                scope.file.jobId = job.jobId;
                                                scope.file.state = 'TRANSCODING';
                                            }
                                        }, function(){
                                            scope.errors.push({
                                                id: 'ue' + Date.now(),
                                                msg: UploadErrors.CREATE_JOB.formatMessage({name: recordingFilePath})
                                            });
                                            scope.cancel();
                                        });
                                }, function(){
                                    scope.errors.push({
                                        id: 'ue' + Date.now(),
                                        msg: UploadErrors.UPDATE_BASEFILE.formatMessage({name: file.name})
                                    });
                                });
                            });
                        }, function(){
                            scope.errors.push({
                                id: 'ue' + Date.now(),
                                msg: UploadErrors.CREATE_BASEFILE.formatMessage({name: recordingFilePath})
                            });
                            scope.cancel();
                        });
                    }, function () {
                        scope.errors.push({
                            id: 'ue' + Date.now(),
                            msg: UploadErrors.CREATE_BATCH
                        });
                    });
                };
            }
        }

    }]);
